<template>
  <section class="page">
    <ListEvents 
      :events="events" 
      :class="{timeline_hidden: !getList}"
    />
    <div class="page-content">
    <transition name="slide">
      <Event 
        v-show="!getMode"
        :event="getActive"
        @deleteEvent="deleting = true"
        @setComplain="setComplain"
        />
    </transition>
    <Map @getLocation="getLocation()" />
    </div>
    <transition name="fade">
      <Filters v-if="showFilters" />
    </transition>
    <transition name="fade">
      <ModalPhotos />
    </transition>
    <transition name="fade">
    <ModalJoin v-if="getJoined" />
    </transition>
    <transition name="fade">
    <ModalParty />
    </transition>
    <transition name="fade">
    <ModalAddUser v-if="getInvite" />
    </transition>
    <transition name="fade">
    <Complain 
      v-if="complain"
      :settings="complain"
      @click.native="complain = null" />
    </transition>
    <transition name="fade">
    <div class="confirm" v-if="deleting">
        <div class="confirm-container">
        <h5>Вы действительно хотите удалить ивент?</h5>
        <p>Вместе с ивентом удалится чат и все трансляции.</p>
        <div class="confirm-buttons">
            <div class="button" @click="deleteEvent()">Да</div>
            <div class="button" @click="deleting = false">Нет</div>
        </div>
        </div>
    </div>
    </transition>
    <SportsWindowNew v-if="showSports" />
  </section>
</template>

<script>
import ListEvents from './components/ListEvents'
import Event from './components/Event'

export default {
  name: 'events',
  components: {
    Event,
    ListEvents,
    ModalPhotos: () => import('@/components/Modals/ModalPhoto'),
    ModalJoin: () => import('./components/ModalJoin'),
    ModalParty: () => import('@/components/Modals/ModalParty'),
    ModalAddUser: () => import('@/components/Modals/ModalAddUser'),
    Filters: () => import('@/components/Filters/Filters'),
    Map: () => import('@/components/Map/Map'),
    Complain: () => import('@/components/Lenta/Complain.vue'),
    SportsWindowNew: () => import('@/components/Filters/SportsWindowNew'),
  },
  data() {
    return {
      events: [],
      deleting: false,
      complain: null
    };
  },
  computed: {
    getEvents() {
      return this.$store.getters.getEvents;
    },
    showSports () {
			return this.$store.getters.sports_new;
    },
    getMode() {
      return this.$store.getters.getMode;
    },
    getList() {
      return this.$store.getters.getList;
    },
    getPage() {
      return this.$store.getters.getEventsPage;
    },
    getBounds() {
      return this.$store.getters.getBounds;
    },
    getActive() {
      return this.$store.getters.getActiveEvent;
    },
    getFilters() {
      return this.$store.getters.getFilters;
    },
    getActiveSports() {
      return this.$store.getters.getActiveSports;
    },
    getTypeEvents() {
      return this.$store.getters.getTypeEvents;
    },
    getInvite() {
      return this.$store.getters.invite;
    },
    showFilters () {
			return this.$store.getters.filters;
    },
    getUser () {
      return this.$store.getters.getAuthUser
    },
    getJoined () {
      return this.$store.getters.joined
    },
  },
  watch: {
    getActive(event) {
      if (event && event.title) {
        document.title = 'WildWood — ' + event.title;
        document.querySelector('meta[name="title"]').setAttribute("content", event.title);
        document.querySelector('meta[property="og:title"]').setAttribute("content", event.title);
        document.querySelector('meta[property="og:image"]').setAttribute("content", event.cover);
        let description = event.content.find(block => block.type === 'paragraph');
        if (description) {
          document.querySelector('meta[property="og:description"]').setAttribute("content", description.value);
        }
      }
    },
    getFilters() {
      clearInterval(this.startLoadingData())
      this.loadData({loading: false});
    },
    getActiveSports() {
      clearInterval(this.startLoadingData())
      this.loadData({loading: true});
    },
    // getMode(mode) {
    //   mode === 'event' || !mode
    //     ? this.fetchEvent()
    //     : '';
    // },
    getBounds() {
      clearInterval(this.startLoadingData())
      this.loadData({loading: true});
    },
    getTypeEvents() {
      clearInterval(this.startLoadingData())
      this.loadData({loading: true});
    },
    $route() {
      this.fetchEvent();
    },
  },
  methods: {
    async loadData({loading}) {
      loading
        ? this.$store.dispatch('setLoader', { element: 'timeline', val: true })
        : '';
      let params = {
        page: this.getPage || 0,
        filters: this.getFilters,
        sports: this.getActiveSports,
        bounds: this.getBounds,
        type: this.getTypeEvents,
        author: this.getUser
      };
      this.events = await this.$store.dispatch('getEvents', params);
      this.$store.dispatch('fetchHotLevel');
      loading
        ? this.$store.dispatch('setLoader', { element: 'timeline', val: false })
        : '';
    },
    async fetchEvent() {
      let hash = this.$route.params.hash;
      if (hash) {
        if (hash.indexOf('&') !== -1) {
          let clear_hash = hash.split('&')[1];
          let id = hash.split('&')[0];
          await this.$store.dispatch('fetchEvent', { hash: clear_hash, id: id });
        } else {
          await this.$store.dispatch('fetchEvent', {hash})
        }
      } else {
        this.$store.dispatch('changeMode', true);
      }
    },
    setComplain(data) {
      this.complain = data
    },
    startLoadingData() {
      return setInterval(async () => {
        this.$route.name == 'events' || this.$route.name == 'event' ? this.loadData({loading: false}) : '';
      }, 2 * 60 * 1000);
    },
    async deleteEvent() {
      await this.$store.dispatch('deleteEvent', {event: this.getActive})
      .then(res => {
        if (res) {
          this.deleting = false
          this.$store.dispatch('addNotification', {message: `Ваше событие удалено`})
          this.$router.push({name: 'events'})
        } else {
          this.$store.dispatch('addError', {message: `Что-то пошло не так...`})
        }
      })
    },
    getLocation() {
      var options = {
        enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
      };
      let success = async pos => {
        let crd = pos.coords;
          let location = {
              latitude: crd.latitude,
              longitude: crd.longitude
          };
          this.$store.dispatch('setCenter', [crd.latitude, crd.longitude])
          let state = await this.$axios.post('/api/zones/by_coords', {coords: location})
          if (state.data) {
            let findedCountry = this.getFilters.find(item => item.group === 'city');
            let filter = {name: state.data.state, state_code: state.data.state_code};
            findedCountry
              ? (
                this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1),
                this.getFilters.push({filter, group: 'city'})
                )
              : '';
            // this.city = {name: state.data.state, state_code: state.data.state_code};
            this.$store.dispatch('setLocation', location);
            this.$store.dispatch('setMapCity', filter)
          }
      }

      let error = () => {
          this.$store.dispatch('addNotification', {message: "Не получилось определить ваше местоположение"})
          this.$store.dispatch('setLocation', {error: true});
          this.getLocationProfile()
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
      
    },
    getLocationProfile() {
      let user_string = localStorage.getItem('user');
      let user = JSON.parse(user_string);
      if (user && user.state_code && user.state) {
        let findedCountry = this.getFilters.find(item => item.group === 'city');
        findedCountry ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1) : '';
        // this.getFilters.push({filter: {name: user.state, state_code: user.state_code}, group: 'city'})
        this.$store.dispatch('setMapCity', {name: user.state, state_code: user.state_code})
        this.$axios.post('/api/zones/by_code', {country: {Iso2: user.country_code}, region: {name: user.state, state_code: user.state_code}})
          .then( res => {
            this.$store.dispatch('setCenter', [res.data.center[1], res.data.center[0]]);
            this.$store.dispatch('setMapZoom', 7);
          })
      }
    }
  },
  mounted() {
    this.loadData({loading: true});
    this.startLoadingData()
  },
  created() {
    this.fetchEvent();
    this.$route.name == 'event' && this.$route.params.hash ? this.$store.dispatch('changeMode', false) : '';
    document.title = this.$route.meta.title;
    this.$store.getters.getLocation && this.$store.getters.getLocation.error 
      ? this.getLocationProfile() 
      : this.getLocation()
  },
};
</script>
